// Array
export const LANGUAGES = ['en', 'it', 'es'];

// String
export const EMPTY_STRING = '';
export const GENERATE_AVATAR_BASE_URL = 'https://ui-avatars.com/api/';
export const INVALID_VALUE = 'Invalid';

// Number
export const DEFAULT_NUMBER_ONE = 1;
export const DEFAULT_NUMBER_ZERO = 0;
export const TIMEOUT_ALERT_MILLISECOND = 3000;
export const DEFAULT_LIMIT = 1000;

// Regex
export const REG_EXP = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  QUERY: /%20/g,
};

// Components

// Date
export const DATE_FORMAT = {
  DATE: 'MM/DD/YYYY',
  LONG_FORMAT: 'MMMM D, YYYY',
  TIME: 'hh:mm A',
};
